function loop(theme, res, list, type) {
  const suffixes = { main: '', light: 'light', ultralight: 'ultralight', dark: 'dark', ultradark: 'ultradark' };
  const suffixe = suffixes[type];
  list.forEach(key => {
    res[`${key}${suffixe}`] = {
      color: theme.palette[key][type],
    };
  });
}

export default theme => {
  const main = [
    'white',
    'black',
    'grey',
    'blue',
    'brown',
    'green',
    'khaki',
    'orange',
    'pink',
    'purple',
    'red',
    'teal',
    'yellow',
  ];
  const light = ['grey', 'red', 'green', 'blue', 'orange', 'purple', 'teal', 'yellow'];
  const ultralight = ['blue', 'green'];
  const dark = ['blue', 'green', 'khaki', 'pink', 'purple', 'red', 'teal'];
  const ultradark = ['red'];

  const res = {
    container: {
      textAlign: 'left',
      backgroundColor: theme.palette.white.main,
      width: 600,
      height: 300,
      [theme.breakpoints.down('md')]: {
        margin: 'auto',
      },
      [theme.breakpoints.down('sm')]: {
        width: 400,
        height: 600,
      },
      [theme.breakpoints.down('xs')]: {
        width: 300,
        height: 500,
      },
    },
    grid: {
      height: '100%',
      [theme.breakpoints.down('sm')]: {
        '& > div': {
          minHeight: '50%',
          width: 'inherit',
        },
      },
    },
    textgreen: {
      backgroundColor: 'green',
    },
    image: {
      width: '100%',
      height: 300,
      objectFit: 'cover',
      [theme.breakpoints.down('xs')]: {
        height: 250,
      },
    },
    textContent: {
      height: '100%',
      padding: theme.spacing(3),
      '& button': {
        marginLeft: -theme.spacing(0.75),
      },
      '& p': {
        marginBottom: theme.spacing(1),
      },
    },
  };

  loop(theme, res, main, 'main');
  loop(theme, res, light, 'light');
  loop(theme, res, dark, 'dark');
  loop(theme, res, ultralight, 'ultralight');
  loop(theme, res, ultradark, 'ultradark');

  return res;
};
